import { PlayerColor } from 'features/board/board'

import { HexBoard, HexId, HexPiece, allowedHexIds } from './hex-board'

interface HexCoords {
  q: number
  r: number
  s: number
}

export interface IPosition {
  x: number
  y: number
}

export const HEX_RADIUS = 150
const divider = '_'
const deltaH = 130
const deltaV = 225
const tileSpacing = 30

export const getHexPosition = ({ playerColor, hexId }: { playerColor: PlayerColor; hexId: HexId }) => {
  const { q, r, s } = decodeHexId(hexId)

  let y = r * deltaV + (r - 1) * tileSpacing
  let x = (q - s) * deltaH + (q - s - 1) * tileSpacing

  // Invert the coordinates for the black player
  if (playerColor === 'black') {
    x = -x
    y = -y
  }

  return { x, y }
}

export const decodeHexId = (hexId: string) => {
  const [_q, _r] = hexId.split(divider)
  const q = parseInt(_q, 10)
  const r = parseInt(_r, 10)
  const s = -q - r

  return { q, r, s }
}

const directionVectors: HexCoords[] = [
  { q: 1, r: 0, s: -1 },
  { q: 1, r: -1, s: 0 },

  { q: 0, r: -1, s: +1 },
  { q: 0, r: +1, s: -1 },

  { q: -1, r: 0, s: +1 },
  { q: -1, r: +1, s: 0 },
]

const generateHexId = (hex: HexCoords) => `${hex.q}${divider}${hex.r}` as HexId

const addDirection = (hexId: HexId, direction: HexCoords) => {
  const { q, r, s } = decodeHexId(hexId)

  return { q: q + direction.q, r: r + direction.r, s: s + direction.s }
}

export const getNeighbors = (hexId?: HexId | null) => {
  if (!hexId) return []

  const neighbors = directionVectors.map(vector => generateHexId(addDirection(hexId, vector)))

  return neighbors.filter(hex => allowedHexIds.includes(hex))
}

export const getNeighborPieces = (hexId: HexId | null, hexBoard: HexBoard): HexPiece[] => {
  if (!hexId) return []

  const neighbors = directionVectors.map(vector => generateHexId(addDirection(hexId, vector)))

  return neighbors.filter(hex => allowedHexIds.includes(hex)).map(hex => hexBoard[hex])
}

export const isNeighbor = (hexA: HexId, hexB: HexId) => getNeighbors(hexA).includes(hexB)
